import React from 'react'
import AdminLayout from '../../components/admin/AdminLayout'

const FaqsMange = () => {
  return (
    <AdminLayout>
 <div>Coming Soon......</div>
    </AdminLayout>
   
  )
}

export default FaqsMange